module.exports = __webpack_public_path__ + "assets/img/folder-open1.503cccaf.svg";